import { render, staticRenderFns } from "./CustomActionPoints.vue?vue&type=template&id=2c598bd8&scoped=true"
import script from "./CustomActionPoints.vue?vue&type=script&lang=js"
export * from "./CustomActionPoints.vue?vue&type=script&lang=js"
import style0 from "./CustomActionPoints.vue?vue&type=style&index=0&id=2c598bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c598bd8",
  null
  
)

export default component.exports